// Must stay the first import: it decrypts localStorage before modules that read it at import time.
import './storageBootstrap'
import { prepareSession } from './sessionBootstrap'

// Sidebar.tsx and PublicSidebar.tsx read localStorage while they are imported, so this tab's session
// key must be in place (exchanged for a new tab or a mobile ?datamoblie=) before the app modules load.
Promise.resolve().then(() => prepareSession(window)).catch(() => undefined).then(() => import('./main'))
